import {
  TAX_CATEGORIES,
  TAX_CATEGORY_ORDER,
  type TaxCategory,
} from '@atek/ca-tax';

export const TAX_CATEGORY_OPTIONS: { value: TaxCategory; label: string }[] = TAX_CATEGORY_ORDER.map(
  (value) => ({ value, label: TAX_CATEGORIES[value].label }),
);
